module.exports = __webpack_public_path__ + "static/media/email.6ae3a96f.svg";